import { operationType } from "../Models/Enums";

export const getFiltersForType = (type) => {
    switch (type) {
        case "Operations":
            return [
                operationType.getName(operationType.REFILL_MANUAL),
                operationType.getName(operationType.REFILL_BY_CASHBOX),
                operationType.getName(operationType.PICKUP_MANUAL),
                operationType.getName(operationType.PICKUP_BY_CASHBOX)
            ];
        case "Cash in":
            return [
                operationType.getName(operationType.SALE),
                "Refund",
                "Cancellation"
            ];
        case "Inventories":
            return [];
        case "Distributions":
            return [
                "Terminal",
                "Cashier"
            ];
        case "Comparisons":
            return [
                "Cash in",
                "Average Cash in",
                "Cash in Number"
            ];
        default:
            return [];
    }
};

export const resolveFilterValueForType = ( type, value ) => {
    const options = getFiltersForType( type );

    if (options.length === 0) {
        return "";
    }

    if ( value && options.includes( value ) ) {
        return value;
    }

    return options[0];
};